const map = {
	"./ar/admin.json": [
		71133,
		[
			1133
		]
	],
	"./de/admin.json": [
		11145,
		[
			1145
		]
	],
	"./en/admin.json": [
		23981,
		[
			3981
		]
	],
	"./es/admin.json": [
		82058,
		[
			2058
		]
	],
	"./fa/admin.json": [
		44735,
		[]
	],
	"./fr/admin.json": [
		51746,
		[
			1746
		]
	],
	"./ja/admin.json": [
		17411,
		[
			7411
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17353;
module.exports = webpackAsyncContext;